// Topic grammar shared with the API: `{scope}/{id}/{kind}`.
// The server refuses anything it does not know, so a drift between these
// constants and the API enums degrades to "no realtime on that topic" (the topic
// comes back in `refusedTopics`), never to a silent failure.

export const RealtimeScope = Object.freeze({
  USERS: 'users',
  ORGANIZATIONS: 'organizations',
});

export const UserTopic = Object.freeze({
  NOTIFICATIONS: 'notifications',
});

export const OrganizationTopic = Object.freeze({
  BOOKINGS: 'bookings',
});

const SEPARATOR = '/';

/** Stands in for the current user: the server rewrites it from the token. */
const SELF = 'me';

export const WILDCARD = '*';

export const userTopic = (kind) =>
  [RealtimeScope.USERS, SELF, kind].join(SEPARATOR);

export const organizationTopic = (organizationId, kind) =>
  [RealtimeScope.ORGANIZATIONS, organizationId, kind].join(SEPARATOR);
